import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

export interface CmdSettings {
  apiBaseUrl: string;
  apiKey?: string;
  apiKeySecretName: string | null;
  apiKeyConfigured: boolean;
  clientId: string;
  otpBrandId: string | null;
  liveChatWorkgroup: string | null;
  liveChatUrl?: string | null;
  requestTrackerWorkgroup: string | null;
  connectTimeoutSeconds: number;
  readTimeoutSeconds: number;
}

export interface EnvironmentProfileAppearance {
  uuid?: string;
  name: string;
  color?: string;
}

export interface EnvironmentProfile extends EnvironmentProfileAppearance {
  version: number;
  cmd: CmdSettings;
}

export const DEFAULT_PROFILE_COLOR = '#3b82f6';

export interface ProfileAssignment {
  clientUuid: string;
  clientName: string;
  environmentProfileUuid: string | null;
}

@Injectable({providedIn: 'root'})
export class EnvironmentProfileService {
  private readonly url = `${environment.API_URL}/api/admin/environment-profiles`;
  constructor(private readonly http: HttpClient) {}

  getAll() { return this.http.get<EnvironmentProfile[]>(this.url); }
  assignments() { return this.http.get<ProfileAssignment[]>(`${this.url}/assignments`); }
  save(profile: EnvironmentProfile) {
    return profile.uuid
      ? this.http.put<EnvironmentProfile>(`${this.url}/${profile.uuid}`, profile)
      : this.http.post<EnvironmentProfile>(this.url, profile);
  }
  assign(clientUuid: string, environmentProfileUuid: string | null) {
    return this.http.put<ProfileAssignment>(`${this.url}/clients/${clientUuid}`, {environmentProfileUuid});
  }
}
